export class TranslateLanguageEntity {
  idTranslateLanguageEntity: number;
  idLanguageEntity: number;
  idLanguage: number;
  one: string;
  many: string;
  locked: boolean;

  constructor(
    idTranslateLanguageEntity: number,
    idLanguageEntity: number,
    idLanguage: number,
    one: string,
    many: string,
    locked: boolean,
  ) {
    this.idTranslateLanguageEntity = idTranslateLanguageEntity;
    this.idLanguageEntity = idLanguageEntity;
    this.idLanguage = idLanguage;
    this.one = one;
    this.many = many;
    this.locked = locked;
  }

  static fromRaw(raw: any): TranslateLanguageEntity {
    return new TranslateLanguageEntity(
      Number(raw.idTranslateLanguageEntity),
      Number(raw.idLanguageEntity),
      Number(raw.idLanguage),
      String(raw.one),
      String(raw.many),
      Boolean(raw.locked),
    );
  }

  clone(): TranslateLanguageEntity {
    return new TranslateLanguageEntity(
      this.idTranslateLanguageEntity,
      this.idLanguageEntity,
      this.idLanguage,
      this.one,
      this.many,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idLanguageEntity: this.idLanguageEntity,
      idLanguage: this.idLanguage,
      one: this.one,
      many: this.many,
    };
    if (this.idTranslateLanguageEntity !== 0) {
      payload.idTranslateLanguageEntity = this.idTranslateLanguageEntity;
    }
    return payload;
  }
}
